export function useFormatedDistance(number, symbol) {
  const formattedNumber = (number / 1000)
    .toFixed(0)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return `${formattedNumber} ${symbol}`;
}
